import { render, staticRenderFns } from "./WizardStepBehaviorKpi.vue?vue&type=template&id=00e0f1a3&scoped=true"
import script from "./WizardStepBehaviorKpi.vue?vue&type=script&lang=js"
export * from "./WizardStepBehaviorKpi.vue?vue&type=script&lang=js"
import style0 from "./WizardStepBehaviorKpi.vue?vue&type=style&index=0&id=00e0f1a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e0f1a3",
  null
  
)

export default component.exports